import { Icon } from "@/components/Icon/Icon";
import type { SubstanceType } from "../_model";

interface TypeGlyphProps {
  type: SubstanceType;
  size?: number;
}

export function TypeGlyph({ type, size = 16 }: TypeGlyphProps) {
  const isMix = type === "mixture";
  return (
    <span
      title={isMix ? "Mixture — multiple compounds" : "Compound — single molecule"}
      style={{
        width: size,
        height: size,
        borderRadius: 4,
        flexShrink: 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: isMix ? "var(--signal-soft)" : "var(--accent-soft)",
        color: isMix ? "#7c5813" : "var(--accent-ink)",
        border: `1px solid ${isMix ? "#e7c97a" : "var(--accent-line)"}`,
      }}
    >
      <Icon name={isMix ? "sprout" : "atom"} size={Math.round(size * 0.6)} />
    </span>
  );
}
